import { TownsquareSiteAri } from '@atlassian/ari';
import { IdentityTeamAri } from '@atlassian/ari/identity';

import { createRelayResource, type RelayResourceConfig } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';

import TeamUpdatesFeedAggQuery, {
	type TeamUpdatesFeedAggQuery as TeamUpdatesFeedAggQueryType,
} from '../TeamUpdatesView/agg/__generated__/TeamUpdatesFeedAggQuery.graphql';

const getTeamAri = (teamId: string): string => {
	try {
		if (IdentityTeamAri.check(teamId)) {
			return teamId;
		}
		return IdentityTeamAri.create({ teamId }).toString();
	} catch {
		return '';
	}
};

export const teamUpdatesAggResource = createRelayResource<TeamUpdatesFeedAggQueryType>({
	getQuery: (routerContext, resourceContext): RelayResourceConfig<TeamUpdatesFeedAggQueryType> => {
		const context = resourceContext as ResourceContext;
		const rawCloudId = context.workspace?.cloudId;
		if (!rawCloudId) {
			throw new Error('No cloudId available');
		}

		const rawTeamId = routerContext?.match?.params.id ?? '';
		return {
			query: TeamUpdatesFeedAggQuery,
			variables: {
				teamId: getTeamAri(rawTeamId),
				containerId: TownsquareSiteAri.create({ siteId: rawCloudId }).toString(),
			},
			environment: getAggRelayEnvironment(),
			options: {
				fetchPolicy: 'store-and-network',
			},
		};
	},
});
